module.exports = __webpack_public_path__ + "static/media/op.4805af15.png";